export interface IGlobalSettingPolicy {
  freeHourNumber: number | null
  moocKeepHourly: number | null
  moocKeepOvernight: number | null
  calculatedByHourNextDay: number | null
  moocKeepLongTerm: number | null
  calculatedFromEvening: number | null
  towingContainerSunday: number | null
  towingContainerHoliday: number | null
  reeferPluginChargesGenerator: number | null
}

const initData = {}

export default { initData }
